import { useTranslation } from "react-i18next";
import { TileGroup, RadioTile } from "@carbon/react";

export interface UserTypeSelectorProps {
  /** "BUYER" | "SELLER" — the current choice, owned by the parent. */
  value: string;
  onChange: (userType: string) => void;
}

/**
 * The BUYER / SELLER choice, rebuilt in Carbon. The pre-Carbon version was two
 * hand-rolled Tailwind `SelectCard` divs (`components/UI/SelectCard`) toggled by
 * `onClick`; this is a real single-select radio group (`TileGroup` + `RadioTile`)
 * so it is keyboard-reachable and announced as a radiogroup, while preserving the
 * exact behaviour: picking a tile drives the parent's `userType`, which sets the
 * `type` sent to `POST /auth/signup` and swaps the Terms & Conditions PDF link.
 */
const UserTypeSelector = ({ value, onChange }: UserTypeSelectorProps) => {
  const { t } = useTranslation();

  return (
    <TileGroup
      name="userType"
      legend={t("register.form.userType")}
      valueSelected={value}
      onChange={(selected) => onChange(String(selected))}
      className="register__user-type"
    >
      <RadioTile id="userType-buyer" value="BUYER">
        {t("register.form.buyer")}
      </RadioTile>
      <RadioTile id="userType-seller" value="SELLER">
        {t("register.form.seller")}
      </RadioTile>
    </TileGroup>
  );
};

export default UserTypeSelector;
